import { useQuery } from '@tanstack/react-query'
import { fetchAggregateMe } from '@/api/aggregateMe'
import { getAccessToken, isDemoSession } from '@/auth/oidc'

/** Always-fresh Aggregate membership for AuthGate (CM useCmMe analogue). */
export function useAggregateMe() {
  const token = getAccessToken()
  const demo = isDemoSession()
  return useQuery({
    queryKey: ['aggregate', 'me', token],
    enabled: Boolean(token) && !demo,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    retry: false,
    queryFn: () => fetchAggregateMe(),
  })
}
